import React from 'react';
import classNames from 'classnames';
import { IPercentageMatchEyecatcher } from './percentageMatchEyecatcher.d';
import { MatchEyecatcherType } from '../../../Common/enums';
import styles from './percentageMatchEyecatcher.scss';

function PercentageMatchEyecatcher(props: IPercentageMatchEyecatcher) {
    const { percentagePoints, displayFeatureNumber, totoalFeatureNumber, eyecatcherType } = props;
    switch (eyecatcherType) {
        case MatchEyecatcherType.percentage: {
            return layout(eyecatcherType, percentagePoints);
        }
        case MatchEyecatcherType.pro:
        case MatchEyecatcherType.contra: {
            return layout(eyecatcherType, displayFeatureNumber, totoalFeatureNumber);
        }
    }

    function layout(type: MatchEyecatcherType, showNumber: number, totalNumber?: number) {
        let displayNumber = 0;
        if (totalNumber && totalNumber > 0 && type !== MatchEyecatcherType.percentage) {
            displayNumber = Math.round(showNumber / totalNumber * 75);
        } else {
            displayNumber = Math.round(showNumber / 100 * 75)
        }
        const displayString = type === MatchEyecatcherType.percentage ? `${showNumber}%` : `${showNumber}`;
        return (
            <div className={classNames(styles.percentage_match_eyecatcher,
                { [styles.pro]: type === MatchEyecatcherType.pro },
                { [styles.contra]: type === MatchEyecatcherType.contra })}>
                <div className={styles.percentage}>
                    <svg viewBox="0 0 100 100" width="50" xmlns="http://www.w3.org/2000/svg">
                        <g transform="rotate(135 50 50)">
                            <circle
                                cx="50" cy="50" r="40"
                                className={styles.percentage_circle_background}
                                pathLength="100"
                                strokeDasharray="75"
                            />
                            <circle
                                cx="50" cy="50" r="40"
                                className={styles.percentage_circle}
                                pathLength="100"
                                strokeDasharray={`${displayNumber} 100`}
                            />
                            <circle
                                cx="50" cy="50" r="35"
                                className={styles.percentage_circle_text_background}
                            />
                            <text
                                transform="rotate(225 50 50)"
                                x="50%"
                                y="50%"
                                dy=".3em"
                                textAnchor="middle"
                                className={styles.percentage_text}
                            >
                                {displayString}
                            </text>
                        </g>
                    </svg>
                </div>
                {
                    type === MatchEyecatcherType.percentage &&
                    <div className={styles.match_text}>match</div>
                }
                {
                    type === MatchEyecatcherType.pro &&
                    <div className={styles.match_text}>pro</div>
                }
                {
                    type === MatchEyecatcherType.contra &&
                    <div className={styles.match_text}>contra</div>
                }
            </div>
        );
    } 
}

export default PercentageMatchEyecatcher;
